import React, { memo, useMemo } from 'react';
import classnames from 'classnames';
import { Text, Avatar } from '@Sage/hoi-poi-ui';
import { DASHBOARD_TYPE } from 'constants/DashboardProviders';
import { getLiteral } from 'utils/getLiteral';
import { theme } from '@Sage/ssm-web5/lib/styles/theme';

const DashboardTabPopover = memo(({ dashboard }) => {
    const typeValue = dashboard?.type?.value;
    const rootClass = classnames('fm-dashboards-tabs__tab-popover', {
        'fm-dashboards-tabs__tab-popover__primary': typeValue === DASHBOARD_TYPE.DEFAULT,
        'fm-dashboards-tabs__tab-popover__info': typeValue === DASHBOARD_TYPE.SFM,
        'fm-dashboards-tabs__tab-popover__focus': [
            DASHBOARD_TYPE.FORCE_BI,
            DASHBOARD_TYPE.METABASE,
        ].includes(typeValue),
    });

    const icon = useMemo(() => {
        switch (typeValue) {
            case DASHBOARD_TYPE.METABASE:
            case DASHBOARD_TYPE.FORCE_BI:
                return 'chart';
            case DASHBOARD_TYPE.SFM:
                return 'salesForce';
            default:
                return 'dashboard';
        }
    }, [typeValue]);

    return (
        <div className={rootClass}>
            <div className="fm-dashboards-tabs__tab-popover__table">
                <div className="fm-dashboards-tabs__tab-popover__row">
                    <div className="fm-dashboards-tabs__tab-popover__column">
                        <Text type="badges" color={theme.colors.textLight.secondary}>
                            {getLiteral('label_description')}:
                        </Text>
                    </div>
                    <div className="fm-dashboards-tabs__tab-popover__column">
                        <Text type="badges" color={theme.colors.textLight.primary}>
                            {getLiteral(dashboard?.description) || '-'}
                        </Text>
                    </div>
                </div>
                {typeValue === DASHBOARD_TYPE.DEFAULT && (
                    <div className="fm-dashboards-tabs__tab-popover__row">
                        <div className="fm-dashboards-tabs__tab-popover__column">
                            <Text type="badges" color={theme.colors.textLight.secondary}>
                                {getLiteral('label_fixed_tab')}:
                            </Text>
                        </div>
                        <div className="fm-dashboards-tabs__tab-popover__column">
                            <Text type="badges" color={theme.colors.textLight.primary}>
                                {getLiteral('label_fixed_tab_desc')}
                            </Text>
                        </div>
                    </div>
                )}
            </div>
            <div className="fm-dashboards-tabs__tab-popover__footer">
                <Avatar icon={icon} size="large" />
                <Text type="subtitle" color={theme.colors.textLight.primary}>
                    {getLiteral(dashboard.title)}
                </Text>
            </div>
        </div>
    );
});

export default DashboardTabPopover;
